import { IReceivedPayment } from "../domain/IReceivedPayment";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getPartnerReceivablesWithPayments,
  selectState,
} from "../slices/dtReceivables.slice";
import Loader from "components/Loader/Loader";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { FormatDateShort } from "utils/dateUtils";
import InfoTooltip from "components/Popup/InfoTooltip";

export const GotPaidPreview = () => {
  const { remainingReceivableAmount, receivedPayments, loading } =
    useSelector(selectState);
  const dispath = useAppDispatch();

  useEffect(() => {
    dispath(getPartnerReceivablesWithPayments());
  }, [dispath]);

  return (
    <div className="daily-table-receivables loading-container">
      {loading && <Loader />}
      <div className="classicHeader bolded">UPLATILI NAM</div>
      <div className="paidPreview">
        <div className="paidHeader">
          <span className="daily-table-invoices-total-label">potražujemo suma</span>
          <span className="daily-table-invoices-total-amount">{FormatNumberWithUnitOrNull(remainingReceivableAmount, 'rsd')}</span>
        </div>
        <div className="paidBody">
          {receivedPayments.map((payment: IReceivedPayment) => (
            <div className="singlePaid">
              <InfoTooltip
                tooltip={payment.partnerName}
                classesProp="daily-table-invoices-item-name text-overflow"
                element="span"
              >
                {payment.partnerName}
              </InfoTooltip>
              <span className="daily-table-invoices-item-amount">{FormatNumberWithUnitOrNull(payment.amount, 'rsd')}</span>
              <span className="daily-table-invoices-item-date">{FormatDateShort(payment.date)}</span>
            </div>
          ))}
          {receivedPayments.length < 6 && <div className="singlePaid"></div>}
          {receivedPayments.length < 5 && <div className="singlePaid"></div>}
          {receivedPayments.length < 4 && <div className="singlePaid"></div>}
          {receivedPayments.length < 3 && <div className="singlePaid"></div>}
          {receivedPayments.length < 2 && <div className="singlePaid"></div>}
          {receivedPayments.length < 1 && <div className="singlePaid"></div>}
        </div>
      </div>
    </div>
  );
};
